import Loader from '../components/Loader'

export default function createLoader(h) {
    return <div style={{
        'position': 'fixed',
        'top': '0',
        'left': '0',
        'height': '100%',
        'width': '100%',
        'z-index': '9999',
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'background-color': 'rgba(255, 255, 255, 0.5)',
    }}>
        <div className="bx-loader">
            <div className="bx-loader-content">
                <Loader/>
                <div className="bx-loader-message">
                    Загрузка...
                </div>
            </div>
        </div>
    </div>;
}
